import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Hero stage component for displaying prominent page headers with imagery.
 *
 * @remarks Provides a reusable hero/stage section for pages with customizable
 * title, subtitle, and background image. Commonly used at the top of pages
 * to create visual hierarchy and establish page context.
 */
@Component({
  selector: 'app-stage',
  templateUrl: './stage.component.html',
  styleUrls: ['./stage.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class StageComponent {
  /** @remarks Main heading text displayed prominently in the stage */
  @Input() title = '';

  /** @remarks Secondary descriptive text displayed below the title */
  @Input() subtitle = '';

  /** @remarks Source URL for the background or featured image */
  @Input() imageSrc = '';

  /** @remarks Alternative text for the image for accessibility purposes */
  @Input() imageAlt = '';
}
